import { render, staticRenderFns } from "./CreateUpdateForm.vue?vue&type=template&id=05d13118"
import script from "./CreateUpdateForm.vue?vue&type=script&lang=js"
export * from "./CreateUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports